import { twMerge } from 'utilities/src/twMerge';
import React from 'react';
import useCardTheme from './themes';

type CardTitleProps = {
  children: string | JSX.Element;
  classes?: string;
  wrapperClasses?: string;
  CustomHeadingTag?: keyof Pick<JSX.IntrinsicElements, 'h1' | 'h2' | 'h3'>;
};

function CardTitle({ children, classes, wrapperClasses, CustomHeadingTag = 'h3' }: CardTitleProps) {
  const { titleClasses, titleVariantClasses } = useCardTheme();

  return (
    <div className={wrapperClasses}>
      <CustomHeadingTag className={classes ?? twMerge(titleClasses, titleVariantClasses)}>
        {children}
      </CustomHeadingTag>
    </div>
  );
}

export default CardTitle;
